import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/inPatientTypes';

export const updateSelectedDetail = (detail: any): Action<any> => {
  return updateAction(actionTypes.SELECTED_INPATIENT_DETAIL, detail);
};

export const updateSelectedBtnType = (value: any): Action<any> => {
  return updateAction(actionTypes.SELECTED_BUTTON_TYPE, value);
};

export const selectedGlobalSearch = (value: any): Action<any> => {
  return updateAction(actionTypes.SELECTED_GLOBAL_SEARCH, value);
};

export const setFilterAction = (value: any): Action<any> => {
  return updateAction(actionTypes.SET_FILTER_ACTION, value);
};
export const setSelectedItem = (value: any): Action<any> => {
  return updateAction(actionTypes.SET_SELECTED_ITEM, value);
};

export const clearSearchDetail = (): Action<any> => {
  return updateAction(actionTypes.CLEAN_SEARCH_DETAIL);
};

export const updateDropdownSearchFilter = (payload: any): Action<any> => {
  return updateAction(actionTypes.UPDATE_DROPDOWN_SEARCH_FILTER, payload);
};

export const searchInPatientList = (): Action<any> => {
  return updateAction(actionTypes.SEARCH_INPATIENT_LIST);
};

export const fetchInPatientList = (payload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_INPATIENT_LIST, payload);
};
export const fetchTotalClaimCount = (payload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_TOTAL_COUNT_LIST, payload);
};

export const fetchTagListCount = (payload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_TAGLIST_COUNT, payload);
};

export const bulkUploadClaims = (bulkUploadPayload: any, callBackFunction: any): Action<any> => {
  return updateAction(actionTypes.BULK_UPLOAD_CLAIMS, {bulkUploadPayload, callBackFunction} );
};

export const setUpdateCourierDetailClicked = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_UPDATE_COURIER_DETAIL_CLICKED, payload);
};

export const setBulkUploadSelectedClaims = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_BULK_UPLOAD_SELECTED_CLAIMS, payload);
};

export const setSortingPreference = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_SORTING_PREFERENCE, payload);
};

export const setPageIndex = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_PAGE_INDEX, payload);
};

export const saveInPatientConfig = (payload: any, setIsVisible: any, configType: string, isDisplayName?: boolean): Action<any> => {
  return updateAction(actionTypes.SAVE_IN_PATIENT_CONFIG, {
    payload, setIsVisible, configType, isDisplayName,
  });
};
export const nextStatusAction = (payload: any): Action<any> =>
  updateAction(actionTypes.NEXT_STATUS_ACTION, payload);

export const setCourierUpdated = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_COURIER_UPDATED, payload);

export const nextStatusFilterAction = (payload: any): Action<any> =>
  updateAction(actionTypes.NEXT_STATUS_FILTER_ACTION, payload);

export const setTPANextStatus = (nextStatus: string): Action<any> =>
  updateAction(actionTypes.SET_TPA_NEXT_STATUS, nextStatus);

export const setTPATimeFilter = (selectedTime: string): Action<any> =>
  updateAction(actionTypes.SET_TIME_FILTER, selectedTime);

export const setBadRequestCount = (badRequestCount: number): Action<any> =>
  updateAction(actionTypes.SET_BAD_REQUEST_COUNT, badRequestCount);

export const setIsGlobalFilter = (isGlobalFilter: boolean): Action<any> =>
  updateAction(actionTypes.SET_GLOBAL_FILTER, isGlobalFilter);

export const setTPASecondaryFilter = (secondaryFilter: string | undefined): Action<any> =>
  updateAction(actionTypes.SET_TPA_SECONDARY_FILTER, secondaryFilter);

export const setCountClicked = (payload: any): Action<any> =>
  updateAction(actionTypes.COUNT_CLICKED_ACTION, payload);

export const setIsDraftBtnClicked = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_DRAFT_BTN_CLICKED, payload);

export const setSettlementValue = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_SETTLEMENT_VALUE, payload);

export const setSelectedTagClass = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_SELECTED_TAG_CLASS, payload);

export const setOtherCourierService = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_OTHER_COURIER_SERVICE, payload);

export const setPayerNotConfig = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PAYER_NOT_CONFIG, payload);

export const setIsAllClicked = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_ALL_CLICKED, payload);

export const resetBulkUploadSelectedClaims = (): Action<any> =>
  updateAction(actionTypes.RESET_BULK_UPLOAD_SELECTED_CLAIMS);

export const deleteKeyfromBulkUploadSelectedClaims = (payload: any): Action<any> => {
  return updateAction(actionTypes.DELETE_KEY_FROM_BULK_UPLOAD_SELECTED_CLAIMS, payload);
};

export const setCenterIdList = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_CENTER_ID_LIST, payload);

export const setIsEasyDischargeCase = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_EASY_DISCHARGE_CASE, payload);

export const setUploadedFiles = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_UPLOADED_FILES, payload);

export const fetchTodaysClaims = (payload: any): Action<any> =>
  updateAction(actionTypes.FETCH_TODAYS_CLAIMS, payload);

export const setIsPreAuthView = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_IS_PRE_AUTH_VIEW, payload);
};
export const setViewCounts = (payload: any): Action<any> => {
    return updateAction(actionTypes.SET_VIEW_COUNTS, payload);
};
export const setSearchDataVisible = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_SEARCH_DATA_VISIBILE, payload);
};
export const setUpdateCourierDetailBtnClicked = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_UPDATE_COURIER_DETAIL_BTN_CLICKED, payload);
};
export const setUpdateCourierDetailBtnClickedFlag = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_UPDATE_COURIER_DETAIL_BTN_CLICKED_FLAG, payload);
};
export const setIsInitiateSettelmentBtnClicked = (payload: any): Action<any> => {
    return updateAction(actionTypes.SET_INITIATE_SETTELMENT_BTN_CLICKED, payload);
};
export const setDisplayFilters = (payload: any): Action<any> => {
  return updateAction(actionTypes.UPDATE_DISPLAY_DROPDOWN_SEARCH_FILTER, payload);
};
export const setSelectedPrimaryFilter = (payload: any): Action<any> => {
  return updateAction(actionTypes.SELECTED_PRIMARY_FILTER, payload);
};
export const setTpaDeskSecondaryFilter = (payload: any): Action<any> => {
  return updateAction(actionTypes.TPA_DESK_SECONDARY_FILTER, payload);
};
export const setIsDownloadClaimsModalOpen = (payload: any): Action<any> => {
  return updateAction(actionTypes.IS_DOWNLOAD_CLAIMS_MODAL_OPEN, payload);
};
export const setIsUploadClaimReportModalOpen = (payload: any): Action<any> => {
  return updateAction(actionTypes.IS_UPLOAD_CLAIM_REPORT_MODAL_OPEN, payload);
};
export const setShowTpaStartDateAndTime = (payload: any): Action<any> => {
  return updateAction(actionTypes.SHOW_TPA_START_DATE_AND_TIME, payload);
};
export const setShowTpaEndDateAndTime = (payload: any): Action<any> => {
  return updateAction(actionTypes.SHOW_TPA_END_DATE_AND_TIME, payload);
};
export const setIsFilteredPopoverVisible = (payload: any): Action<any> => {
  return updateAction(actionTypes.IS_FILTERED_POPOVER_VISIBLE, payload);
};
export const setShowSelectedTpaPrimaryFilter = (payload: any): Action<any> => {
  return updateAction(actionTypes.SHOW_SELECTED_TPA_PRIMARY_FILTER, payload);
};
export const setShowSelectedTpaSecondaryFilters = (payload: any): Action<any> => {
  return updateAction(actionTypes.SHOW_SELECTED_TPA_SECONDARY_FILTERS, payload);
};
export const setIsDateChanged = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_IS_DATE_CHANGED, payload);
};
export const setIsClaimDetailApiLoaded = (payload: any): Action<any> => {
  return updateAction(actionTypes.IS_CLAIM_DETAIL_API_LOADED, payload);
};
export const setSelectedDateDropdown = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_SELECTED_DATE_DROPDOWN, payload);
};
export const setTpaGlobalSearchClicked = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_TPA_GLOBAL_SEARCH_CLICKED, payload);
};
export const setTpaGlobalSearch = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_TPA_GLOBAL_SEARCH, payload);
};
export const setTpaGlobalSearchValue = (payload: string): Action<string> => {
  return updateAction(actionTypes.SET_TPA_GLOBAL_SEARCH_VALUE, payload);
};
export const resetInPatientFilters = (): Action<any> => {
  return updateAction(actionTypes.RESET_INPATIENT_FILTERS);
};
export const setElapseTimeDropdown = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_ELAPSED_TIME_DROPDOWN, payload);
};
export const setElapsedTimeColorConfig = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_ELAPSED_TIME_COLOR_CONFIG, payload);
};
export const setSelectedElapsedTimeRemarks = (payload: any): Action<any> => {
  return updateAction(actionTypes.SELECTED_ELAPSED_TIME_REMARKS, payload);
};
export const fetchFollowUpDetails = (payload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_FOLLOWUP_DETAILS, payload);
};
export const setFollowUpDetails = (payload: any ): Action<any> => {
  return updateAction(actionTypes.FOLLOWUP_DETAILS, payload);
};
export const setFollowUpDetailsPayload = (payload: any): Action<any> => {
  return updateAction(actionTypes.FOLLOW_UP_DETAILS_PAYLOAD, payload);
};
export const followUpConfirmation = (payload: any): Action<any> => {
  return updateAction(actionTypes.FOLLOW_UP_CONFIRMATION, payload);
};
